import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createPromotional,
  getAPromotional,
  resetState,
  updateAPromotional,
} from "../features/promotype/promotypeSlice";

let schema = yup.object().shape({
  promotype_name: yup.string().required("Promotional Type is Required"),
});

const AddPromoType = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getPromoTypeId = location.pathname.split("/")[3];
  const newPromotype = useSelector((state) => state.promoType);
  const {
    isSuccess,
    isError,
    isLoading,
    createdPromotional,
    promotionalName,
    updatedPromotional,
  } = newPromotype;

  useEffect(() => {
    if (getPromoTypeId !== undefined) {
      dispatch(getAPromotional(getPromoTypeId));
    } else {
      dispatch(resetState());
    }
  }, [getPromoTypeId]);

  useEffect(() => {
    if (isSuccess && createdPromotional) {
      toast.success("Promotional Type Added Successfully!");
      navigate("/admin/list-Promotional");
      dispatch(resetState());
    }
    if (isSuccess && updatedPromotional) {
      toast.success("Promotional Type Updated Successfully!");
      navigate("/admin/list-Promotional");
      dispatch(resetState());
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdPromotional, updatedPromotional, navigate, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      promotype_name: promotionalName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getPromoTypeId !== undefined) {
        // await dispatch(updateAPromotional({
        //     id: getPromoTypeId, 
        //     promoTypeData: values
        //   }));
         const data = { id: getPromoTypeId, promoTypeData: values };
                dispatch(updateAPromotional(data));
      } else {
        dispatch(createPromotional(values));
        formik.resetForm();
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getPromoTypeId !== undefined ? "Edit" : "Add"} Promotional Type
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <div>
            <label className="form-label" htmlFor="promotype_name">
              Promotional Type Name <span className="text-danger">*</span>
            </label>
            <CustomInput
              type="text"
              label="Enter Product Promotional Type"
              onChng={formik.handleChange("promotype_name")}
              onBlr={formik.handleBlur("promotype_name")}
              val={formik.values.promotype_name}
              id="promotype_name"
              name="promotype_name"
            />
            <div className="error">
              {formik.touched.promotype_name && formik.errors.promotype_name}
            </div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getPromoTypeId !== undefined ? "Edit" : "Add"} Promotional Type
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPromoType;